import React from "react";
import styles from "./Home.module.css";
import Panel from "./Panel";
import { formatDay } from "../../../utils/weekDates";

const TAGS = {
  leave_request: "Leave request",
  overbooked: "Overbooked",
  overdue: "Overdue",
  over_budget: "Over budget",
  missing_timesheets: "Timesheets",
};

const describe = (item) => {
  if (item.type === "leave_request") {
    const { start_date: s, end_date: e, working_days: d } = item.detail;
    return `${s === e ? formatDay(s) : `${formatDay(s)} – ${formatDay(e, true)}`} · ${d} working ${d === 1 ? "day" : "days"}`;
  }
  if (item.type === "overdue") return `Was due ${formatDay(item.end_date)}`;
  if (item.type === "overbooked") return "Open the schedule to move some bookings";
  return item.detail;
};

// Leave approvals, overbooked people, overdue and over-budget projects and missing timesheets, each with its next action.
export default function NeedsAttention({ items, canApprove, onDecide, onOpen, onRemind, onDismiss }) {
  const actions = (item) => {
    if (item.type === "leave_request" && canApprove) {
      return (
        <>
          <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={() => onDecide(item, "approved")}>Approve</button>
          <button type="button" className={styles.btn} onClick={() => onDecide(item, "rejected")}>Decline</button>
        </>
      );
    }
    if (item.type === "missing_timesheets") return <button type="button" className={styles.btn} onClick={() => onRemind(item)}>Send reminder</button>;
    const label = item.type === "leave_request" ? "Open leave" : item.type === "overbooked" ? "Open schedule" : "Open project";
    return <button type="button" className={styles.btn} onClick={() => onOpen(item)}>{label}</button>;
  };

  return (
    <Panel title="Needs attention" count={items.length || null}>
      {items.length === 0 ? (
        <div className={styles.empty}>Nothing needs your attention.</div>
      ) : (
        <div className={styles.attnList}>
          {items.map((item) => (
            <div key={item.key} className={styles.attn}>
              <span className={styles.attnTag}>{TAGS[item.type]}</span>
              <div style={{ minWidth: 0 }}>
                <div className={styles.attnTitle}>{item.title}</div>
                <div className={styles.attnDetail}>{describe(item)}</div>
              </div>
              <div className={styles.attnActions}>{actions(item)}</div>
              <button type="button" className={styles.iconBtn} aria-label="Dismiss" onClick={() => onDismiss(item.key)}>×</button>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
